<template>
  <div id="properties-container">
    <!--  Informacion general sobre el objeto  -->
    <div class="bg-white shadow overflow-hidden rounded-lg mt-0">
      <div class="px-2 py-2 md:px-4 md:py-5 bg-gray-100">
        <div class="text-base leading-6 font-medium text-gray-900">
          Información general
          <span v-if="getSelectedElement.type === 'folder'">
            de la carpeta
          </span>
          <span v-if="getSelectedElement.type === 'file'">
            del archivo
          </span>
          <span class="font-bold">{{getSelectedElement.name}}</span>
          <div class="identification">ID: {{getSelectedElement.id}}</div>
        </div>
      </div>
      <div class="border-t border-gray-200">
        <div class="grid grid-cols-12 gap-5">
          <div class="col-span-12 lg:col-span-4 ml-0">
            <!-- OWNER -->
            <vs-list class="ml-0">
              <ChangeOwnerView />
              <!-- EVALUATION -->
              <div
                class="vs-list--item"
                v-if="getSelectedElement.type === 'file'"
              >
                <div class="list-titles">
                  <div
                    class="vs-list--title cursor-pointer d-flex align-items-center"
                    @click="activeVotationForm"
                  >
                    <b-form-rating
                      no-border
                      id="evaluation-form"
                      v-model="getSelectedElement.evaluation"
                      stars="5"
                      inline
                      variant="warning"
                      size="lg"
                      class="p-0 h-3"
                      :readonly="true"
                      precision
                      v-tooltip="'Promedio de las evaluaciones'"
                    />
                    <span
                      v-tooltip="'Cantidad de evaluaciones'"
                      class="badge badge-warning ml-2"
                    >
                      {{getSelectedElement.totalEvaluations}}
                    </span>
                  </div>
                  <div class="vs-list--subtitle">
                    <span>Evaluación</span>
                  </div>
                </div>
              </div>
              <!-- SIZE -->
              <vs-list-item
              v-if="getSelectedElement.type === 'file'"
                :title="size"
                subtitle="Tamaño"
              />
              <!-- TYPE -->
              <vs-list-item
                v-if="getSelectedElement.type === 'folder'"
                title="Carpeta"
                subtitle="Tipo"
              />
              <vs-list-item
                v-if="getSelectedElement.type === 'file'"
                title="Documento"
                subtitle="Tipo"
              />
              <!-- PUBLICATION STATE -->
              <div class="vs-list--item" v-if="getSelectedElement.type === 'file'">
                <div class="list-titles">
                  <div class="vs-list--title">
                      <span>
                        <font-awesome-icon
                          :icon="['fas', publicationStateIcon(getSelectedElement).icon]"
                          :class="publicationStateIcon(getSelectedElement).classes"
                        />
                        {{ publicationStateIcon(getSelectedElement).message }}
                      </span>
                  </div>
                  <div class="vs-list--subtitle">
                    <span>Estado de publicación</span>
                  </div>
                </div>
              </div>
              <!-- ACCESS TYPE -->
              <vs-list-item
                v-if="getSelectedElement.type === 'file' && getSelectedElement.isPublic"
                title="Publico"
                subtitle="Tipo de acceso"
              />
              <vs-list-item
                v-else-if="getSelectedElement.type === 'file'"
                title="Privado"
                subtitle="Tipo de acceso"
              />
            </vs-list>
          </div>
          <div class="col-span-12 lg:col-span-4">
            <vs-list>
              <!-- name -->
              <vs-list-item
                :title="getSelectedElement.name"
                subtitle="Nombre de elemento"
              />
              <!-- URL -->
              <div
                class="vs-list--item"
                v-if="getSelectedElement.type === 'file'"
              >
                <div class="list-titles">
                  <div class="vs-list--title">
                    <div v-if="getSelectedElement.publicLink">
                      <a
                        class="float-left lg:w-48 xl:w-48 truncate cursor-pointer public-link"
                        v-tooltip="'Descarga el archivo'"
                        :href="getSelectedElement.publicLink"
                        target="_BLANK"
                      >
                        Archivo público
                      </a>
                      <vs-icon
                        icon="content_copy"
                        size="small"
                        class="text-purple cursor-pointer align-top"
                        :class="{'animated pulse': copyIconClicked}"
                        v-tooltip="'Copiar link para compartir'"
                        v-clipboard:copy="getSelectedElement.publicLink"
                        v-clipboard:success="onCopy"
                      />
                    </div>
                    <span v-else>--</span>
                  </div>
                  <div class="vs-list--subtitle">
                    <span>URL</span>
                  </div>
                </div>
              </div>
              <!-- MIME TYPE -->
              <vs-list-item
                v-if="getSelectedElement.type === 'file'"
                :title="getSelectedElement.mimeType || '--'"
                subtitle="MIME Type"
              />
              <!-- PUBLISHER -->
              <vs-list-item
                v-if="getSelectedElement.type === 'file'"
                :title="getSelectedElement.owner || '--'"
                subtitle="Publicador"
              />
              <!-- INTERNAL VERSION -->
              <vs-list-item
                v-if="getSelectedElement.type === 'file'"
                :title="getSelectedElement.internalVersion.toString() || '--'"
                subtitle="Versión interna"
              />
            </vs-list>
          </div>
          <div class="col-span-12 lg:col-span-4">
            <vs-list>
              <!-- CERATION DATE -->
              <vs-list-item
              v-if="getSelectedElement.creationDate"
                :title="$moment(getSelectedElement.creationDate).format('LLLL')"
                subtitle="Fecha de creación"
              />
              <vs-list-item
                v-else
                :title="'--'"
                subtitle="Fecha de creación"
              />
              <!-- PUBLISH DATE -->
              <vs-list-item
                v-if="getSelectedElement.type === 'file' && getSelectedElement.publicationDate"
                :title="$moment(getSelectedElement.publicationDate).format('LLLL')"
                subtitle="Fecha de publicación"
              />
              <vs-list-item
                v-else
                :title="'--'"
                subtitle="Fecha de publicación"
              />
              <!-- EXTERNAL VERSION -->
              <vs-list-item
                v-if="getSelectedElement.type === 'file'"
                :title="getSelectedElement.externalVersion || '--'"
                subtitle="Versión externa"
              />
              <!-- VALIDITY STATE -->
              <div class="vs-list--item" v-if="getSelectedElement.type === 'file'">
                <div class="list-titles">
                  <div class="vs-list--title">
                      <span>
                        <font-awesome-icon
                          :icon="['fas', validityStateIcon(getSelectedElement).icon]"
                          :class="validityStateIcon(getSelectedElement).classes"
                        />
                        {{ validityStateIcon(getSelectedElement).message }}
                      </span>
                    <span class="small text-muted" v-if="getSelectedElement.expirationDate">
                      ({{ getSelectedElement.expirationDate }})
                    </span>
                  </div>
                  <div class="vs-list--subtitle">
                    <span>Vencimiento</span>
                  </div>
                </div>
              </div>
              <!-- APPROVAL STATE -->
              <div class="vs-list--item" v-if="getSelectedElement.type === 'file'">
                <div class="list-titles">
                  <div class="vs-list--title">
                    <span>
                      <font-awesome-icon
                        :icon="['fas', approvalStateIcon(getSelectedElement).icon]"
                        :class="approvalStateIcon(getSelectedElement).classes"
                      />
                      {{ approvalStateIcon(getSelectedElement).message }}
                    </span>
                  </div>
                  <div class="vs-list--subtitle">
                    <span>Estado de aprobación</span>
                  </div>
                </div>
              </div>
            </vs-list>
          </div>
        </div>
      </div>
    </div>
    <!-- TAGS -->
    <EDTagsForm />
    <!-- KEYWORDS -->
    <EDKeywordsForm />
    <!-- EVALUATION FORM -->
    <EvaluationForm />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import ChangeOwnerView from '@/febos/global/documentManagement/vistas/ChangeOwnerView';
import EvaluationForm from '@/febos/global/documentManagement/vistas/modals/EvaluationForm';
import EDTagsForm from '@/febos/global/documentManagement/components/EDTagsForm';
import EDKeywordsForm from '@/febos/global/documentManagement/components/EDKeywordsForm';
import EDIcons from '@/febos/global/documentManagement/mixins/EDIcons';

export default {
  name: 'PropertiesView',
  components: {
    EvaluationForm,
    EDTagsForm,
    EDKeywordsForm,
    ChangeOwnerView
  },
  props: {
    detailItem: Object
  },
  data() {
    return {
      averageScore: 0,
      disabledKeywords: true,
      tags: [],
      keywords: [],
      tableFields: ['tipo', 'clave', 'valor'],
      copyIconClicked: false,
      editingOwner: false,
    };
  },
  mixins: [EDIcons],
  methods: {
    ...mapActions('Modals', [
      'showModals',
      'changeInformation'
    ]),
    onCopy() {
      this.copyIconClicked = true;
      setTimeout(() => {
        this.copyIconClicked = false;
      }, 1000);
    },
    activeVotationForm() {
      this.showModals('evaluationFormED');
    },
    roundToTwoDecimals(num) {
      return Math.round((num + Number.EPSILON) * 100) / 100;
    },
  },
  computed: {
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('DocManagement', [
      'getSelectedElement'
    ]),
    size() {
      if (typeof this.getSelectedElement.size === 'undefined' || this.getSelectedElement.size === '') {
        return '--';
      }
      const units = ['bytes', 'kb', 'mb', 'gb', 'tb'];
      let actualUnit = 0;
      const amountOfUnitsForNextLevel = 1024;
      let actualSize = this.getSelectedElement.size;
      while (actualSize >= amountOfUnitsForNextLevel) {
        actualSize = this.roundToTwoDecimals(actualSize / amountOfUnitsForNextLevel);
        actualUnit += 1;
      }
      return [actualSize, units[actualUnit]].join(' ');
    }
  }
};
</script>

<style scoped>
  .btn.btn-ligth {
    padding: 0 !important;
  }
  .vuesax-app-is-ltr{
    margin-left: 0px !important;
  }
  .vs-list--slot{
    margin-left: 0px !important;
    color: rgba(255, 217, 0, 0.932);
  }
  .identification{
    color: #aaa;
    font-size: 10px;
  }
  .public-link{
    border-radius: 3px;
    background-color: #aa0000;
    color:white;
    width: 80px;
    text-align: center;
  }
</style>
